// Grab our variantOptions element
const variantOptionsEl = document.getElementById('variantOptions');

// Check if element exists before parsing
if (!variantOptionsEl) {
  console.error('variantOptions element not found');
  throw new Error('variantOptions element not found');
}

let optionsJSON, options, variantsData;
try {
  optionsJSON = JSON.parse(variantOptionsEl.innerText);
  ({ options, variantsData } = optionsJSON);

  // Validate the data structure
  if (!options || !Array.isArray(options)) {
    throw new Error('Invalid options array in variantOptions JSON');
  }
  if (!variantsData || typeof variantsData !== 'object') {
    throw new Error('Invalid variantsData object in variantOptions JSON');
  }
} catch (e) {
  console.error('Error parsing variantOptions JSON:', e);
  throw e;
}

const visibleClass = 'product-option--visible';

function checkOptionAvailability(options) {
  // If product has single variant return
  if (options.length <= 1) {
    // For single option products, we still need to check variant visibility
    // Loop through all variants and hide/show based on quantity and hidden metafield
    const allVariantInputs = document.querySelectorAll(`.product-option__${options[0]}`);

    allVariantInputs.forEach((variantInput) => {
      const inputValue = variantInput.value;
      const inputParent = variantInput.closest('.product-option');
      const key = inputValue; // For single option, the key is just the value itself

      const variantData = variantsData[key];
      const hideWhenSoldOut = variantData ? variantData.hidden : true;

      // Hide only if the hidden metafield is explicitly set to true
      const shouldHide = hideWhenSoldOut === true;

      inputParent.classList.toggle(visibleClass, !shouldHide);

      // Also handle add to cart bar option
      const addToCartBarOption = document.querySelector(`.add-to-cart-section option[value="${inputValue}"]`);
      if (addToCartBarOption) {
        addToCartBarOption.classList.toggle(visibleClass, !shouldHide);
      }
    });
  } else {
    // Build array containing selected option values for each option in the `options` array
    const selectedOptions = options.map((option) => document.querySelector(`.product-option__${option}:checked`)?.value);

    // Loop through each option
    options.forEach((option, optionIndex) => {
      // Build list of each variant input within the fieldset for the current `option`
      const allVariantInputs = document.querySelectorAll(`.product-option__${option}`);

      // Loop through variant inputs for current option
      allVariantInputs.forEach((variantInput) => {
        const inputValue = variantInput.value;
        const inputParent = variantInput.closest('.product-option');

        /*
          Create array with values that make up the key in `variantsData`
            - Key varies depeding on the index of the `option` we are currently looping over
        */
        const keyValues = selectedOptions.map((selectedOption, selectedIndex) => {
          return selectedIndex === optionIndex ? inputValue : selectedOption
        })

        /*
          Join the values with ' / '
            - This will match the unique value of the combined variant options Shopify returns in `product.variants[i].title`, which is used as the key in `variantsData`
        */
        const key = keyValues.join(' / ');
        
        // Check quantity in the object we added in liquid
        const variantData = variantsData[key];
        const hideWhenSoldOut = variantData ? variantData.hidden : true;

        // Corresponding add to cart bar option
        const addToCartBarSelect = document.querySelector(`.add-to-cart-bar .option-select[data-option-name="${option}"]`);
        const addToCartBarOption = addToCartBarSelect ? addToCartBarSelect.querySelector(`option[value="${inputValue}"]`) : null;

        // Remove or add class to variant option that makes the option visible (all 'size' options should always be visible)
        // Hide only if the hidden metafield is explicitly set to true (and it's not a 'size' option)
        const shouldHide = hideWhenSoldOut === true && option !== 'size';

        inputParent.classList.toggle(visibleClass, !shouldHide);
        if (addToCartBarOption) {
          addToCartBarOption.classList.toggle(visibleClass, !shouldHide);
          // Don't hide the option in select, just disable it
          if (shouldHide) {
            addToCartBarOption.setAttribute('disabled', 'disabled');
          } else {
            addToCartBarOption.removeAttribute('disabled');
          }
        }
      });
    });

    /*
      If the selected variant options do not existing as a product, select the first available option for that size
      This senario only happens with Size options since all size options are always visible, but a secondary option might not be available in that size
    */
    const selectedVariantKey = selectedOptions.join(' / ');
    if (!variantsData[selectedVariantKey] || (variantsData[selectedVariantKey].quantity === 0 && variantsData[selectedVariantKey].hidden === true)) {
      const optionNames = options.filter((option) => option != 'size');
      optionNames.forEach(optionName => {
        const fieldset = document.querySelector(`fieldset[data-option-name="${optionName}"]`);
        if (fieldset) {
          const firstAvailabile = fieldset.querySelector(`.${visibleClass} label`);
          firstAvailabile ? firstAvailabile.click() : null;
        }
      });
    }

    // Update the sticky add to cart button text according to if the value of the select is in stock
    const addToCartBarButton = document.querySelector('.add-to-cart-bar .add-to-cart__button');
    const addToCartBarSelects = document.querySelectorAll('.add-to-cart-bar .option-select');
    
    if (addToCartBarButton && addToCartBarSelects.length > 0) {
      // Build array of selected values from all selects
      const selectedValues = Array.from(addToCartBarSelects).map(select => select.value);
      const key = selectedValues.join(' / ');
      const variantData = variantsData[key];
      
      // Check if variant exists and is available
      const isAvailable = variantData && (variantData.quantity > 0 || variantData.hidden !== true);
      
      if (!isAvailable) {
        addToCartBarButton.textContent = 'Out of Stock';
        addToCartBarButton.setAttribute('disabled', true);
      } else {
        addToCartBarButton.querySelector('span').textContent = 'Add to Cart';
        addToCartBarButton.removeAttribute('disabled');
      }
    }
  }
}

// Run on page load
checkOptionAvailability(options);

// Code to check for input change here
const productOptionInputs = document.querySelectorAll('.product-option input');
productOptionInputs.forEach((productOptionInput) => {
  productOptionInput.addEventListener('change', () => {
    // Run again when a different option is selected
    checkOptionAvailability(options);
  });
});